import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ico-1",
  "use": "ico-1-usage",
  "viewBox": "0 0 37.55 46.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37.55 46.39\" id=\"ico-1\"><title>资源 22</title><g id=\"ico-1_图层_2\" data-name=\"图层 2\"><g id=\"ico-1_图层_1-2\" data-name=\"图层 1\"><path d=\"M29.27,27.61h-21a1.66,1.66,0,1,0,0,3.31h21a1.66,1.66,0,0,0,0-3.31Z\" /><path d=\"M29.27,34.24h-21a1.66,1.66,0,1,0,0,3.31h21a1.66,1.66,0,0,0,0-3.31Z\" /><path d=\"M35.89,42.15a1.66,1.66,0,0,0,1.66-1.66V3.31A3.31,3.31,0,0,0,34.24,0H3.31A3.31,3.31,0,0,0,0,3.31V43.07a3.31,3.31,0,0,0,3.31,3.31H34.24a3.31,3.31,0,0,0,3.31-3.31V39.21a1.66,1.66,0,1,0-3.31,0v3.87H3.31V3.31H34.24V40.49a1.66,1.66,0,0,0,1.66,1.66Z\" /><path d=\"M8.28,12.15h8.84a1.66,1.66,0,0,0,0-3.31H8.28a1.66,1.66,0,1,0,0,3.31Z\" /><path d=\"M8.28,18.78h8.84a1.66,1.66,0,1,0,0-3.31H8.28a1.66,1.66,0,1,0,0,3.31Z\" /><path d=\"M30.92,9.94a1.1,1.1,0,0,0-1.1-1.1H23.19a1.1,1.1,0,0,0-1.1,1.1v7.73a1.1,1.1,0,0,0,1.1,1.1h6.63a1.1,1.1,0,0,0,1.1-1.1V9.94Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/ico-1.svg
// module id = txF0
// module chunks = 268